import { Box } from "@mui/material";
import PropTypes from "prop-types";
import React, { forwardRef, useImperativeHandle, useRef } from "react";

const NativeScrollbar = forwardRef(function NativeScrollbar(
  { children, className, style, options, ...rest },
  ref,
) {
  const containerRef = useRef(null);

  useImperativeHandle(
    ref,
    () => ({
      _container: containerRef.current,
    }),
    [],
  );

  const suppressScrollX = Boolean(options?.suppressScrollX);

  return (
    <Box
      ref={containerRef}
      className={className}
      style={style}
      sx={{
        position: "relative",
        overflowY: "auto",
        overflowX: suppressScrollX ? "hidden" : "auto",
        minHeight: 0,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
});

NativeScrollbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  options: PropTypes.shape({
    suppressScrollX: PropTypes.bool,
  }),
};

NativeScrollbar.defaultProps = {
  children: null,
  className: undefined,
  style: undefined,
  options: undefined,
};

export default NativeScrollbar;
